import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/logo.png";

// import "../styles/sidebar.css";

const Sidebar = () => {
  const { user } = useAuth();
  const role = user?.role;

  const can = (...roles) => roles.includes(role);

  return (
    <aside className="sidebar">
      <div>
        <div className="sidebar-brand">
  <img src={logo} alt="Logo" className="sidebar-logo" />
  <span>Croplyra Pos Demo Admin</span>
</div>


        <nav className="sidebar-nav">
          {can("SUPER_ADMIN", "ADMIN", "MANAGER") && (
            <NavLink to="/" className="sidebar-link">
              Dashboard
            </NavLink>
          )}

          {can("SUPER_ADMIN", "ADMIN") && (
            <NavLink to="/branches" className="sidebar-link">
              Branches
            </NavLink>
          )}

          {can("SUPER_ADMIN", "ADMIN") && (
            <NavLink to="/users" className="sidebar-link">
              Users
            </NavLink>
          )}

          {can("SUPER_ADMIN", "ADMIN", "MANAGER") && (
            <NavLink to="/products" className="sidebar-link">
              Products
            </NavLink>
          )}

          {can("SUPER_ADMIN", "ADMIN", "MANAGER") && (
            <NavLink to="/inventory" className="sidebar-link">
              Inventory
            </NavLink>
          )}

          {can("SUPER_ADMIN", "ADMIN", "MANAGER", "CASHIER") && (
            <NavLink to="/invoices" className="sidebar-link">
              Invoice History
            </NavLink>
          )}

          {can("SUPER_ADMIN", "ADMIN", "MANAGER") && (
            <NavLink to="/reports" className="sidebar-link">
              Reports
            </NavLink>
          )}

          {can("CASHIER", "BILLING") && (
            <NavLink to="/billing" className="sidebar-link billing">
              Billing
            </NavLink>
          )}

          {can("SUPER_ADMIN") && (
            <NavLink to="/settings" className="sidebar-link">
              Settings
            </NavLink>
          )}
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
